(function () {

	"use strict";

	// Gets value from a form control
	function getValue(ctrl, func) {

		var output = undefined;

		if (this.elements[ctrl]) {

			output = this.elements[ctrl].value.trim();

			if (func && func.constructor === Function) {

				output = func(output);
			}
		}

		return output;
	}

	// Polyfill for Array.prototype.includes
	function includes(val) {

		return (this.indexOf(val) !== -1);
	}

	if (!HTMLFormElement.prototype.getValue) {

		Object.defineProperty(HTMLFormElement.prototype, 'getValue', { value : getValue });
	}

	if (!HTMLFieldSetElement.prototype.getValue) {

		Object.defineProperty(HTMLFieldSetElement.prototype, 'getValue', { value : getValue });
	}

	if (!Array.prototype.includes) {

		Object.defineProperty(Array.prototype, 'includes', { value : includes });
	}
}());
